import * as React from "react";
import { memo } from "react";
const SvgHeadlineBackground = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", xmlns: "http://www.w3.org/2000/svg", width: 197, height: 39, viewBox: "0 0 197 39", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L197 0C197 21.5391 179.539 39 158 39H0L0 0Z", fill: "#F9DC5C" }));
const Memo = memo(SvgHeadlineBackground);
export default Memo;
